
<template>
  <div class="history">
       <p class="ptitle">- Our Story -</p>
       <img :src="shou" alt="" class="icon1">

       <div class="historybox">
         <div class="left">
             <div class="p1">{{listData[0].name}}</div>
             <p class="p2">{{listData[0].content.subtitle}}</p>
         </div>
         <div class="right">
           <div class="line" v-for="(item,index) in listData" :key="item.id" v-if="(index > 0)">
            <p class="p1">{{item.name}}<br/>{{item.content.keywords}}</p>
            <p class="p2">{{item.content.subtitle}}</p>
            ​<br/>
           </div>
          

            <div class="igbox">
              <div class="p3" @click="go(tmig)">脫毛IG：NOMOMOHK<div class="a1"><img :src="ins" alt="" class="icon"></div></div>
              <div class="p3" @click="go(qbig)">淡斑IG：NOBANBANHK<div class="a1"><img :src="ins" alt="" class="icon"></div></div>
            </div>
            <img :src="hua" alt="" class="hua">
         </div>
       </div>
  </div>
</template>

<script>
import { Recommend,settings} from '../../api/userMG'


export default {
 name:'history',
 data() {
   return {
     shou:require("@/assets/img/shou.png"),
     hua:require("@/assets/img/hua10.png"),
     tmig:'',
     qbig:'',
     ins:require("@/assets/img/ins.png"),
       webname:'nomomo',
     webkey:'激光脫毛</br>​激光祛斑祛印',
     listData:[
       {
         name:'',
         content:{
           keywords:'',
           subtitle:''}}
     ],
    
     params:{
       mt_id:3
     }

   }
 },
 // 註冊組件
 components: {


   
 },
 /**
  * 數據發生改變
  */

 /**
  * 創建完畢
  */
 created() {
   
 },
 mounted() {
   this.getdata(this.params)
   this.getdata2('脱毛IG')
   this.getdata3('祛斑IG')
},
 /**
  * 裏麵的方法隻有被調用才會執行
  */
 methods: {
  go(url){
     
    
     window.open(url, '_blank');
   },
   getdata2(parameter) {

   
   

settings(parameter)
 .then(res => {
   this.loading = false

   if (res.data.code != 1) {
     this.$message({
       type: 'info',
       message: res.message
     })
   } else {
       let dd=res.data.data.data
     if(dd.length>0){
       let path=JSON.parse(dd[0].content)['val']

       this.tmig=path

     }
  
      
   }
 })
 .catch(err => {
   this.loading = false
   this.$message.error('菜單加載失敗，請稍後再試！')
 })
},
getdata3(parameter) {

   
   

settings(parameter)
 .then(res => {
   this.loading = false

   if (res.data.code != 1) {
     this.$message({
       type: 'info',
       message: res.message
     })
   } else {
       let dd=res.data.data.data
     if(dd.length>0){
       let path=JSON.parse(dd[0].content)['val']

       this.qbig=path
    
     }
  
      
   }
 })
 .catch(err => {
   this.loading = false
   this.$message.error('菜單加載失敗，請稍後再試！')
 })
},
   // 獲取公司列錶
   getdata(parameter) {
     this.loading = true
   

     /***
      * 調用接口，註釋上麵模擬數據 取消下麵註釋
      */
      Recommend(parameter)
       .then(res => {
         this.loading = false
   
         if (res.data.code != 1) {
           this.$message({
             type: 'info',
             message: res.data.message
           })
         } else {
           res.data.data.data.forEach(el => {
             el.content=JSON.parse(el.content)
         
           });
           this.listData = res.data.data.data

         }
       })
       .catch(err => {
         this.loading = false
         this.$message.error('菜單加載失敗，請稍後再試！')
       })
   }

  
 }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/home/history.vue